var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoCircleGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0026 1.83203C4.32927 1.83203 1.33594 4.82536 1.33594 8.4987C1.33594 12.172 4.32927 15.1654 8.0026 15.1654C11.6759 15.1654 14.6693 12.172 14.6693 8.4987C14.6693 4.82536 11.6759 1.83203 8.0026 1.83203ZM7.5026 5.83203C7.5026 5.5587 7.72927 5.33203 8.0026 5.33203C8.27594 5.33203 8.5026 5.5587 8.5026 5.83203V9.16536C8.5026 9.4387 8.27594 9.66536 8.0026 9.66536C7.72927 9.66536 7.5026 9.4387 7.5026 9.16536V5.83203ZM8.61594 11.4187C8.5826 11.5054 8.53594 11.572 8.47594 11.6387C8.40927 11.6987 8.33594 11.7454 8.25594 11.7787C8.17594 11.812 8.08927 11.832 8.0026 11.832C7.91594 11.832 7.82927 11.812 7.74927 11.7787C7.66927 11.7454 7.59594 11.6987 7.52927 11.6387C7.46927 11.572 7.4226 11.5054 7.38927 11.4187C7.35594 11.3387 7.33594 11.252 7.33594 11.1654C7.33594 11.0787 7.35594 10.992 7.38927 10.912C7.4226 10.832 7.46927 10.7587 7.52927 10.692C7.59594 10.632 7.66927 10.5854 7.74927 10.552C7.90927 10.4854 8.09594 10.4854 8.25594 10.552C8.33594 10.5854 8.40927 10.632 8.47594 10.692C8.53594 10.7587 8.5826 10.832 8.61594 10.912C8.64927 10.992 8.66927 11.0787 8.66927 11.1654C8.66927 11.252 8.64927 11.3387 8.61594 11.4187Z",
    fill: "url(#paint0_linear_18157_107400)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18157_107400",
    x1: 2.19868,
    y1: 1.83203,
    x2: 17.8754,
    y2: 18.8391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#9360A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46B7E9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircleGradient);
export default __webpack_public_path__ + "static/media/infoCircleGradient.dac5d442cc9066a51c6646e08c8a0996.svg";
export { ForwardRef as ReactComponent };